import { useTheme } from "../../context/theme";
import colorWithOpacity from "../../utils/colorWithOpacity";

export type ShadowSize = "xsmall" | "small" | "medium" | "large" | "xlarge";

type ShadowProperties = {
  horizontalOffset: number;
  verticalOffset: number;
  blur: number;
  opacity: number;
};

export const SHADOW_SIZE_TO_PROPERTIES_MAP: {
  [key in ShadowSize]: ShadowProperties;
} = {
  xsmall: {
    horizontalOffset: 0,
    verticalOffset: 4,
    blur: 10,
    opacity: 0.03
  },
  small: {
    horizontalOffset: 0,
    verticalOffset: 4,
    blur: 14,
    opacity: 0.05
  },
  medium: {
    horizontalOffset: 0,
    verticalOffset: 6,
    blur: 20,
    opacity: 0.07
  },
  large: {
    horizontalOffset: 0,
    verticalOffset: 8,
    blur: 20,
    opacity: 0.09
  },
  xlarge: {
    horizontalOffset: 0,
    verticalOffset: 10,
    blur: 26,
    opacity: 0.12
  }
};

export default function useShadow(size: ShadowSize) {
  const properties = SHADOW_SIZE_TO_PROPERTIES_MAP[size];
  const { horizontalOffset, verticalOffset, blur, opacity } = properties;

  const theme = useTheme();
  const shadowColor = theme.shadow;
  const shadowColorWithOpacity = colorWithOpacity(shadowColor, opacity);

  return `${horizontalOffset}px ${verticalOffset}px ${blur}px ${shadowColorWithOpacity}`;
}
